module.exports = __webpack_public_path__ + "static/img/011.09310a89.png";